import type { ColumnDef } from "@tanstack/react-table";
import type { ApReceipt } from "@/accounts-payable/types";
import { formatCentsOrDashIfZero } from "@/core/utils/money";
import { cn } from "@/core/utils/utils";

export const totalCol: ColumnDef<ApReceipt> = {
  accessorKey: "total_amount_cents",
  header: () => <span className="flex-1 text-right">Total</span>,
  meta: { size: "110px" },
  cell: ({ row }) => (
    <span
      className={cn("block pr-6 text-right font-semibold tabular-nums", {
        "text-negative-text": row.original.total_amount_cents < 0,
      })}
    >
      {formatCentsOrDashIfZero(row.original.total_amount_cents)}
    </span>
  ),
};
